import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { constantRouterMap } from './routerMap'
Vue.use(Router)

NProgress.configure({ showSpinner: false })

const router = new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
// 白名单
const whiteList = ['/login', '/401', '/404'] // no redirect whitelist
router.beforeEach((to, from, next) => {
  // console.log(`before: from:${from.path}, to:${to.path}`)
  if (whiteList.includes(to.path)) return next()
  NProgress.start()
  if (to.matched.length === 0) { // 当前没有匹配到路由 进入404页面
    next('/404')
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.done()
})

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
